import { convertObjectSnakeCaseToCamelCaseProperties } from '../../../../kernel/mappers'
import { getFormattedDate, FULL_DATE_TIME_FORMAT_WITH_T, FULL_DATE_TIME_FORMAT } from '../../../../utils/dates'
import { Job } from '../../domain/job'
import { HelaJob, Item, ItemStatus } from '../../domain/job-hela'

export const mapHelaJobToOldJob = (helaJob: HelaJob): Job => {
  const nebulaJob = helaJob.nebula_job

  const job: Job = {
    uuid: nebulaJob.id,
    jobNumber: nebulaJob.job_number,
    origin: nebulaJob.origin,
    destination: convertObjectSnakeCaseToCamelCaseProperties(nebulaJob.destination),
    receiver: convertObjectSnakeCaseToCamelCaseProperties(nebulaJob.receiver),
    paymentMethod: nebulaJob.payment_info.payment.method,
    paymentDetail: nebulaJob.payment_info.payment.method_details,
    paymentReference: nebulaJob.payment_info.payment.reference,
    status: nebulaJob.status,
    partialStatus: helaJob.custom_fields.partial_status,
    itemsStatusCount: getItemsStatusCount(nebulaJob.items),
    storeTimezone: nebulaJob.store.timezone,
    slotFrom: nebulaJob.slot.from,
    slotTo: nebulaJob.slot.to,
    operationModel: nebulaJob.slot.operational_model,
    createdAt: nebulaJob.created_at,
    updatedAt: nebulaJob.updated_at,
    isBigOrder: nebulaJob.is_big_order,
    storeTzCreatedAt: getFormattedDate({
      date: nebulaJob.created_at,
      format: FULL_DATE_TIME_FORMAT_WITH_T,
      timezoneIn: 'Etc/UTC',
      timezoneOut: nebulaJob.store.timezone
    }),
    storeTzUpdatedAt: getFormattedDate({
      date: nebulaJob.updated_at,
      format: FULL_DATE_TIME_FORMAT_WITH_T,
      timezoneIn: 'Etc/UTC',
      timezoneOut: nebulaJob.store.timezone
    }),
    storeTzSlotFrom: getFormattedDate({
      date: nebulaJob.slot.from,
      format: FULL_DATE_TIME_FORMAT_WITH_T,
      timezoneIn: 'Etc/UTC',
      timezoneOut: nebulaJob.store.timezone
    }),
    storeTzSlotTo: getFormattedDate({
      date: nebulaJob.slot.to,
      format: FULL_DATE_TIME_FORMAT_WITH_T,
      timezoneIn: 'Etc/UTC',
      timezoneOut: nebulaJob.store.timezone
    }),
    tasks: nebulaJob.tasks.map((task) => ({
      uuid: task.id,
      name: task.type,
      status: task.status,
      resources: {
        firstName: task.contact_info?.name,
        lastName: '',
        phoneNumber: task.contact_info?.phone,
        photoUrl: task.contact_info?.photo_url,
        resourceId: task.contact_info?.resource_id,
        fleetId: task.fleet?.name || ''
      },
      departments: task.departments,
      storeId: task.store_id,
      stopMetadata: task.stop_metadata
        ? {
            order: task.stop_metadata.order,
            storeName: task.stop_metadata.store_name
          }
        : null
    })),
    paymentValue: nebulaJob.payment_info.prices.order_value,
    shippingFee: nebulaJob.payment_info.prices.shipping_fee,
    logisticCostCurrency: nebulaJob.payment_info.currency_code,
    source: nebulaJob.source,
    externalData: {
      backoffice: {
        orderCode: nebulaJob.external_data?.backoffice?.order_code
      }
    },
    previousSlot: helaJob.actions
      ? {
          storeTzSlotFrom: getFormattedDate({
            date: helaJob.actions.rescheduled.last_slot_from,
            format: FULL_DATE_TIME_FORMAT,
            timezoneIn: 'Etc/UTC',
            timezoneOut: nebulaJob.store.timezone
          }),
          storeTzSlotTo: ''
        }
      : null
  }
  return job
}

const getItemsStatusCount = (items: Item[]) => {
  return items.reduce(
    (count, item) => {
      switch (item.status) {
        case ItemStatus.PENDING:
          count.pending++
          break
        case ItemStatus.ADDED:
          count.added++
          break
        case ItemStatus.REMOVED:
        case ItemStatus.CANCELLED:
          count.removed++
          break
        case ItemStatus.REJECTED:
          count.rejected++
          break
        default:
          break
      }
      return count
    },
    {
      added: 0,
      pending: 0,
      rejected: 0,
      removed: 0
    }
  )
}
